/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
const NumLayout = {
    normal: [
        [
            { value: "1", type: "standard" },
            { value: "2", type: "standard" },
            { value: "3", type: "standard" }
        ],
        [
            { value: "4", type: "standard" },
            { value: "5", type: "standard" },
            { value: "6", type: "standard" }
        ],
        [
            { value: "7", type: "standard" },
            { value: "8", type: "standard" },
            { value: "9", type: "standard" }
        ],
        [
            { value: ".", type: "standard" },
            { value: "0", type: "standard" },
            { value: "<-", type: "2vertical" }
        ],
        [{ value: "Save", type: "2horizontal" }]
    ]
};

export default NumLayout;
